import { api } from '@/api';
import { RootState } from '@/store/index';
import { Instruction } from '@/types/Instruction';
import { Record } from '@/types/Record';
import { Video } from '@/types/Video';
import { Method } from 'axios';
import { ActionContext, Module } from 'vuex';

export type RecordsState = {
    records: Record[];
};

export const records: Module<RecordsState, RootState> = {
    state: {
        records: [],
    },
    mutations: {
        addRecord(state: RecordsState, record: Record) {
            const index = state.records.findIndex(
                (r) => r.video_id === record.video_id && r.instruction_id === record.instruction_id,
            );

            if (index === -1) {
                state.records.push(record);
            } else {
                state.records.splice(index, 1, record);
            }
        },
    },
    getters: {
        records: (state): Record[] => state.records,
    },
    actions: {
        async uploadRecord(
            context: ActionContext<RecordsState, RootState>,
            payload: { value: string | Blob; instruction: Instruction; video: Video; record?: Record },
        ) {
            const { value, instruction, video } = payload;
            const record: Partial<Record> = {
                ...payload.record,
            };

            try {
                switch (instruction.type) {
                    case 'text':
                        await api.post(`/videos/${video.id}/properties`, {
                            name: instruction.property_name,
                            value,
                        });

                        context.commit('addRecord', {
                            ...record,
                            instruction_id: instruction.id,
                            video_id: video.id,
                            value: value,
                        });

                        break;
                    case 'video':
                        const fileResponse = await api.post('/files?use=url', {
                            filename: `video-${video.id}-${instruction.id}.webm`,
                            type: 'video',
                        });
                        if (!fileResponse || !fileResponse.data) {
                            throw new Error('Unexpected response');
                        }
                        const { file, method, url } = fileResponse.data as {
                            file: {
                                id: number;
                                filename: string;
                                type: string;
                            };
                            method: Method;
                            url: string;
                        };

                        await fetch(url, {
                            method,
                            headers: {
                                'Content-Type': (value as Blob).type,
                            },
                            body: value,
                        });

                        const videoFileResponse: {
                            id: string;
                            url: string;
                        } = await api.post(`/videos/${video.id}/files`, {
                            file_id: file.id,
                            template_instruction_id: instruction.id,
                        });

                        context.commit('addRecord', {
                            ...record,
                            instruction_id: instruction.id,
                            video_id: video.id,
                            video_file_id: videoFileResponse.id,
                            value: videoFileResponse.url,
                            file_id: file.id,
                        });

                        break;
                    default:
                        // console.log(instruction.type);
                        break;
                }

                return true;
            } catch (error) {
                // console.error(error);
            }

            return false;
        },
    },
};
